module.exports = __webpack_public_path__ + "static/OrangeCouchTwitter-6e2211c7e2c1e948599c20828486796e.jpg";